/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Ats_Pass_TitleInputs */

const en_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Optimized Results`)
};

const de_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimierte Ergebnisse`)
};

const fr_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultats optimises ATS`)
};

const es_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados optimizados ATS`)
};

const it_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati ottimizzati ATS`)
};

const nl_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-geoptimaliseerde resultaten`)
};

const pl_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyniki zoptymalizowane pod ATS`)
};

const fi_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimoidut tulokset`)
};

const da_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimerede resultater`)
};

const sv_landing_feature_ats_pass_title = /** @type {(inputs: Landing_Feature_Ats_Pass_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-optimerade resultat`)
};

/**
* | output |
* | --- |
* | "ATS-Optimized Results" |
*
* @param {Landing_Feature_Ats_Pass_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_ats_pass_title = /** @type {((inputs?: Landing_Feature_Ats_Pass_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Ats_Pass_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_ats_pass_title(inputs)
	if (locale === "fr") return fr_landing_feature_ats_pass_title(inputs)
	if (locale === "es") return es_landing_feature_ats_pass_title(inputs)
	if (locale === "it") return it_landing_feature_ats_pass_title(inputs)
	if (locale === "nl") return nl_landing_feature_ats_pass_title(inputs)
	if (locale === "pl") return pl_landing_feature_ats_pass_title(inputs)
	if (locale === "fi") return fi_landing_feature_ats_pass_title(inputs)
	if (locale === "da") return da_landing_feature_ats_pass_title(inputs)
	if (locale === "sv") return sv_landing_feature_ats_pass_title(inputs)
	return en_landing_feature_ats_pass_title(inputs)
});